<template>
    <div>
        <transition name="fade" mode="out-in">
            <div v-if="newPasswordSent">
                <h2>Nieuw wachtwoord verzonden</h2>
                <p>Er is een e-mail verstuurd net uw nieuwe wachtwoord naar e-mailadres.</p>
                <a href="#" class="button--cta" @click.prevent="changeAuthView('LoginForm')">Terug naar inlogscherm</a>
            </div>
            <form class="form" v-else>
                <h3>{{$t('auth.change_password')}}</h3>

                <div class="form__item">
                    <input class="form__input--text" type="password" autocomplete="password" name="password" v-model="password" :placeholder="$t('auth.hint_password')"/>
                </div>

                <div class="form__item">
                    <input class="form__input--text" type="password" autocomplete="password" name="password" v-model="repeatPassword" :placeholder="$t('auth.hint_password')"/>
                </div>

                <div class="form__buttons">
                    <button type="submit" class="button--cta" @click.prevent="change">Verander wachtwoord</button>
                    <router-link :to="{ name: 'sign-in'}" type="button" class="button--link">Annuleren</router-link>
                </div>
            </form>
        </transition>
    </div>
</template>

<script>
    import Vue from 'vue';
    import Component from 'vue-class-component';

    @Component
    export default class PasswordResetForm extends Vue {
        name = 'password-reset-form';
        newPasswordSent = false;

        token = '';

        password = '';
        repeatPassword = '';

        created() {
            this.token = this.$route.params.token;
            if (!this.token) {
                this.$router.replace({ name: 'reset' });
            }
        }

        /**
         * Request a new password
         */
        change() {
            //TODO call api.
        }
    }

    Vue.component('password-reset-form', PasswordResetForm);
</script>



// WEBPACK FOOTER //
// src/components/auth/forms/PasswordResetForm.vue